<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Collection Type {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Collection Type - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Collection Type - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div>
                <base-input alternative="" label="Code" placeholder="" required v-model="inputCode" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="inputRemark" />
                </base-input>
                <base-input alternative="" label="Required Fields">
                    <a-select
                        class="mb-1"
                        v-model="inputRequiredFields"
                        mode="multiple"
                        style="width: 100%"
                        optionFilterProp="children"
                        :disabled="viewMode"
                        allowClear
                        >
                            <a-select-option v-for="field in collection_fields"
                                :key="field.code"
                                :value="field.code">
                                {{ field.name }}
                            </a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="Minimum Downpayment" type="number" placeholder=""  v-model="inputMinDownpayment" input-classes="form-control" />
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;

    const collection_fields = [
        { code: 'delivery_receipt_no', name: 'Delivery Receipt Number' },
        { code: 'pickup_date', name: 'Pickup Date' },
        { code: 'receiving_store', name: 'Receiving Store' },
        { code: 'delivery_date', name: 'Delivery Date' },
        { code: 'event_contract_no', name: 'Event Contract Number' },
        { code: 'event_date', name: 'Event Date' }
    ]

    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this

            if (this.profileId > 0) {
                var collection_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'collection_types/' + component_x.profileId , null)

                if (collection_type_data == undefined) {
                    alert("SOMETHING WENT WRONG")
                    // component_x.$router.go()
                } else {
                    if (collection_type_data["error"] == undefined) {
                        component_x.inputName = collection_type_data["name"]
                        component_x.inputCode = collection_type_data["code"]
                        component_x.inputRemark = collection_type_data["remark"]
                        component_x.inputRequiredFields = collection_type_data["required_fields"] || []
                        component_x.inputMinDownpayment = collection_type_data["minimum_amount"] || []
                    } else {
                        this.errors = collection_type_data["error"].split(",")
                    }
                }
            }
        },
        data: function () {
            return {
                collection_fields,
                inputName: '',
                inputCode: '',
                inputRemark: '',
                inputRequiredFields: [],
                inputMinDownpayment: 0.0,
                
                errors: [],
                viewMode: this.$attrs.viewMode 
            }
        },
        methods: {
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                this.errors.push(ValidateField.required('Name', this.inputName));

                this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    var collection_type_payload = {
                        collection_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                            required_fields: this.inputRequiredFields,
                            minimum_amount: Number(this.inputMinDownpayment),
                            status: 'A',
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'collection_types', null, collection_type_payload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    var collection_type_payload = {
                        collection_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                            required_fields: this.inputRequiredFields,
                            minimum_amount: Number(this.inputMinDownpayment),
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'collection_types/' + this.profileId, null, collection_type_payload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
            selectRequiredFields(field) {
                if (this.inputRequiredFields.includes(field)) {
                    var fieldIndex = this.inputRequiredFields.indexOf(field);
                    this.inputRequiredFields.splice(fieldIndex, 1);
                } else {
                    this.inputRequiredFields.push(field)
                }
            },
        }
    }
</script>